import React from 'react'

// Types
import { ColumnProps } from '../types'

// Styles
import styles from '../styles/Column.scss'

const Column: React.FC<ColumnProps> = (props) => {
  const { className } = props
  return (
    <div
      {...props}
      className={`${styles.column} ` + (className || '')}
    />
  )
}

export default Column
